"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousRoute
 * @description Baasic Notifications Subscriptions Anonymous Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Anonymous Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var _1 = require("./");
var NotificationsSubscriptionsAnonymousRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsAnonymousRoute, _super);
    function NotificationsSubscriptionsAnonymousRoute(notificationsSubscriptionsAnonymousBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/anonymous';
        _this.findRoute = 'notifications/subscriptions/anonymous/{?searchQuery,registrationIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/anonymous/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/anonymous/{id}';
        _this.updateRoute = 'notifications/subscriptions/anonymous/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousRoute.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create anonymous subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousRoute.create();
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find anonymous subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `registrationIds` - Comma separated list of anonymous registration identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.find({
                   searchQuery: '<search-phrase>',
                   channels: '<channel-name>,<channel-name>'
               });
    */
    NotificationsSubscriptionsAnonymousRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.get({id: '<subscription-id>'});
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.delete(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to update specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.update(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousRoute);
    return NotificationsSubscriptionsAnonymousRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsAnonymousRoute = NotificationsSubscriptionsAnonymousRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
